import { RULE_NODE_TYPES } from "../components/GraphBuilder/Nodes/utils/constants";
import type {
  NODE_TYPE,
  WorkflowNodeData,
} from "../components/GraphBuilder/Nodes/utils/types";

/**
 * Determines whether a source node can accept a new child of the given placement type.
 */
export const canAcceptPlacement = (
  sourceNode: WorkflowNodeData,
  placementNodeType: NODE_TYPE,
): boolean => {
  if (
    sourceNode.nodeType === RULE_NODE_TYPES.CONDITIONAL_SPLIT ||
    sourceNode.nodeType === RULE_NODE_TYPES.WORKING_HOURS
  ) {
    return false;
  }

  if (
    placementNodeType === RULE_NODE_TYPES.REDIRECT_TO_STEP &&
    (sourceNode.childNodeIds?.length ?? 0) > 0
  ) {
    return false;
  }

  return true;
};

/**
 * Determines whether the copied node can be pasted onto an edge (spliced
 * between the edge's source and its child). Copied splits can only be
 * leaf-appended — the BE rejects a paste with childNodeId for them. A terminal
 * node ends its path, so it can only be appended as a leaf, never spliced
 * between two existing nodes.
 */
export const canPasteAtEdge = (
  sourceNode: WorkflowNodeData,
  copiedNode: WorkflowNodeData,
): boolean => {
  if (
    copiedNode.nodeType === RULE_NODE_TYPES.CONDITIONAL_SPLIT ||
    copiedNode.nodeType === RULE_NODE_TYPES.WORKING_HOURS
  ) {
    return false;
  }

  if ((copiedNode.formValues as { isTerminal?: boolean } | undefined)?.isTerminal) {
    return false;
  }

  return canAcceptPlacement(sourceNode, copiedNode.nodeType);
};
